module.exports = __webpack_public_path__ + "img/尾部bg@2x.5f21dc8d.png";